import { hydrateRoot, createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { ThemeProvider } from "./components/theme-provider";
import { AuthProvider } from "./context/AuthContext";
import { initSentry } from "@/lib/sentry";
import { onCLS, onINP, onFCP, onLCP, onTTFB } from "web-vitals";
import * as Sentry from "@sentry/react";
import "./index.css";

// Initialize Sentry first
initSentry();

// Report Core Web Vitals to Sentry
const sendToSentry = ({ name, delta, value, id }: any) => {
  Sentry.captureMessage(`Web Vital: ${name}`, {
    level: "info",
    tags: {
      "web-vital": name,
    },
    extra: {
      value,
      delta,
      id,
    },
  });
};

// Track Core Web Vitals (only if Sentry is configured and not in dev)
if (import.meta.env.VITE_SENTRY_DSN && !import.meta.env.DEV) {
  onCLS(sendToSentry);
  onINP(sendToSentry); // Replaced FID with INP (Interaction to Next Paint)
  onFCP(sendToSentry);
  onLCP(sendToSentry);
  onTTFB(sendToSentry);
}

const rootElement = document.getElementById("root")!;

// Support react-snap pre-rendering with React 18 API
// If the root has children, hydrate the pre-rendered content
// Otherwise, render normally
const appElement = (
  <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider defaultTheme="light">
          <App />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </HelmetProvider>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, appElement);
} else {
  createRoot(rootElement).render(appElement);
}
